import React, { useState, useEffect } from "react";
import axios from "axios";
import Header from "../components/layout/header";
import border from "../images/border.png";
import CategorySection from "../components/CategorySection";
import CarouselSection from "../components/CarouselSection";
import img1 from "../images/Rectangle 122.png";
import img2 from "../images/Rectangle 123.png";
import Footer from "../components/layout/footer";
import NewArrivals from "../components/New Arrivals/NewArrivals";
import ImageSlider from "../components/ImageSlider/ImageSlider";
import SliderHome from "../components/SacredOfferingsSlider/SliderHome";
import bamboo from ".././images/bamboo.png";
import DealOfTheDay from "./Home/DealOfTheDay";
import JustArrived from "./Home/JustArrived";
import SaleBanner from "./Home/SaleBanner";
import TopSelerExellence from "./Home/TopSelerExellence";
import OnTriendPic from "./Home/OnTrendPicks";
import CommunityStats from "./Home/CommunityStats";
import SockSection from "./Home/SockSelection";
import VideoComponent from "./Home/VideoComponent";
import OnTrendProduct from "./Home/OnTrendPicks";
import OnTrendPic from "./Home/OnTrendPicks";
import OnTrendPicks from "./Home/OnTrendPicks";
import United4 from ".././images/color.png";
import CouponCode from "./Home/CouponCode";
import ColouredProducts from "./Home/ColouredProducts/ColouredProducts";
import FlashSale from "./Flash Sale/FlashSale";
import ShapeWear from "./ShapeWear/ShapeWear";
import { BASE_URL } from "../constant";
import { useNavigate } from "react-router-dom";
import CategoryCarousel from "./Home/Category_Carousel/Category_Carousel";

const Home = ({ setNavigatedCategory }) => {
  const [SeasonsUrl, setSeasonsUrl] = useState("");
  const [BambooUrl, setBambooUrl] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 500);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 500);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchSeasonsImage = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/homepage/images/get-season`
        );
        setSeasonsUrl(response.data);
      } catch (error) {
        console.error("Error fetching shapewear image:", error);
      }
    };
    const fetchBambooImage = async () => {
      try {
        const response = await axios.get(
          `${BASE_URL}/homepage/images/get-bamboo`
        );
        setBambooUrl(response.data);
      } catch (error) {
        console.error("Error Fetching Bamboo Socks Image: ", error);
      }
    };

    fetchSeasonsImage();
    fetchBambooImage();
  }, []);

  const handleButtonClick = (redirectUrl) => {
    if (redirectUrl) {
      navigate(redirectUrl);
    } else {
      navigate("/shop?category=Cotton");
    }
  };
  return (
    <div>
      <Header setNavigatedCategory={setNavigatedCategory} />

      {isMobile ? "" : <CategoryCarousel />}
      <CarouselSection />
      <CouponCode />
      <VideoComponent />
      <section>
        <DealOfTheDay title={" Deal Of The Day "} />
        <ShapeWear />
      </section>
      {/*<JustArrived />*/}
      <ColouredProducts />
      <div>
        {SeasonsUrl ? (
          <img
            src={SeasonsUrl.imageUrl}
            alt="United3"
            text="Third slide"
            className="d-block w-100"
            onClick={() => handleButtonClick(SeasonsUrl.redirectUrl)}
            style={{ maxHeight: "100vh" }}
          />
        ) : (
          <p>Loading Image</p>
        )}
      </div>
      <OnTrendPicks />
      <div>
        {BambooUrl ? (
          <img
            src={BambooUrl.imageUrl}
            alt="bamboo"
            text="Third slide"
            onClick={() => handleButtonClick(BambooUrl.redirectUrl)}
            className="d-block w-100 object-fit-cover"
          />
        ) : (
          <p>Loading Image</p>
        )}
      </div>

      <CommunityStats />
      <SockSection />
      <TopSelerExellence />
      <Footer />
    </div>
  );
};

export default Home;
